import { useState, useEffect } from "react";

const heroSectionStyle = {
  textAlign: "center",
  minHeight: "30vh",
  padding: "100px 110px 100px 110px",
  color: "#fff",
  background: "linear-gradient(to left, #f5f9ff,rgb(70, 77, 96))",
};

const heroSectionStyleTablet = {
  textAlign: "center",
  minHeight: "25vh",
  padding: "160px 60px 80px 60px",
  color: "#fff",
  background: "linear-gradient(to left, #f5f9ff,rgb(70, 77, 96))",
};

const heroSectionStyleMobile = {
  textAlign: "center",
  minHeight: "20vh",
  padding: "60px 30px 60px 30px",
  color: "#fff",
  background: "linear-gradient(to left, #f5f9ff,rgb(70, 77, 96))",
};

function HeroSection() {
  const [screenSize, setScreenSize] = useState("desktop");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setScreenSize("mobile");
      } else if (window.innerWidth <= 1024) {
        setScreenSize("tablet");
      } else {
        setScreenSize("desktop");
      }
    };

    // Set initial screen size
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Clean up event listener
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getHeroStyle = () => {
    switch (screenSize) {
      case "mobile":
        return heroSectionStyleMobile;
      case "tablet":
        return heroSectionStyleTablet;
      default:
        return heroSectionStyle;
    }
  };

  const getTitleStyle = () => {
    switch (screenSize) {
      case "mobile":
        return { fontSize: "28px", fontWeight: "bold", margin: 0 };
      case "tablet":
        return { fontSize: "32px", fontWeight: "bold", margin: 0 };
      default:
        return { fontSize: "36px", fontWeight: "bold", margin: 0 };
    }
  };

  return (
    <div style={getHeroStyle()}>
      <h1 style={getTitleStyle()}>Pricing</h1>
    </div>
  );
}

export default HeroSection;